import { Display } from '@/components/Display/Display';
import s from '../../Outside/pages/style/chat.module.scss';
import LinkGuide from '../LinkGuide';
import preImg from '@/assets/images/mobile/pre_icon.png';
import UserCards from '../CaseSimulation/UserCards';
const PreQuestion = ({
    type = 'agent',
    currentAgent = {},
    submitMsg,
    pre_question_json = [],
    clickGuide,
    clickGuideS,
    showGuide,
    guideData = [],
    disabled = false,
    isTTSMode = false,
    isCaseSimulation = false,
    curSkill = {},
    sessionId = ''
}) => {
    return (
        <>
            <div className={s['chats-top']}>
                <Display show={type === 'agent'}>
                    <div className={s['no-content']}>
                        <div className={s['introduce']}>{currentAgent?.introduction || `Hi~，我是${currentAgent.name}`}</div>
                    </div>
                </Display>
                <Display show={type === 'skill'}>
                    <div className={s['no-content']}>
                        <div className={s['introduce']}>{currentAgent?.introduction || `${currentAgent.name}`}</div>
                    </div>
                </Display>

                <Display show={!isCaseSimulation}>
                    <Display show={showGuide}>
                        <LinkGuide onClick={clickGuideS} data={guideData}></LinkGuide>
                    </Display>
                    <Display show={pre_question_json && pre_question_json.length}>
                        <div className={s['preset-question-wrap']}>
                            {/* <div className={s['preset-question-title']}>
                                <img src={preImg} alt="" /> 试试这样问我
                            </div> */}
                            <div className={s['preset-question-list']}>
                                {pre_question_json &&
                                    pre_question_json.map((ele, index) => {
                                        return (
                                            <div
                                                onClick={() => {
                                                    // 在TTS模式下禁用预设问题点击
                                                    if (!isTTSMode && !disabled) {
                                                        submitMsg(ele, true);
                                                    }
                                                }}
                                                key={index}
                                                className={`${s['preset-question-item']} ${isTTSMode || disabled ? s['disabled'] : ''}`}
                                            >
                                                <div className={s['preset-question-item-text']}>{ele}</div>
                                                {/* <Tooltip title={ele}>{ele}</Tooltip> */}
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </Display>
                </Display>
            </div>
        </>
    );
};
export default PreQuestion;
